<ndt-role-detail-view
   [role]="role$ | async"
   [privileges]="privileges$ | async"
   [rolePrivileges]="rolePrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [extensions]="extensions$ | async"
   [extensionGroups]="extensionGroups$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (deleteRole)="onDeleteRole($event)"
></ndt-role-detail-view>
